import React from "react";
import "./Select.css";
import { isReadonlyStringArray } from "../../utils/utils";

interface SelectProps extends React.HTMLProps<HTMLSelectElement> {
  containerId: string;
  label: string;
  options: string[];
  optionsValues: string[];
  classNameBox?: string;
  idBox?: string;
  iconArrow?: React.ReactNode;
  selectValue?: (value: string | number | null) => void;
}

export const Select: React.FC<SelectProps> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [currentOption, setCurrentOption] = React.useState<
    typeof props.defaultValue
  >(getOptionByValue(props.defaultValue));

  class Arrow {
    static opened() {
      const arrow = document.getElementById(`${props.id}_selectArrow`);
      if (arrow) arrow.style.transform = "rotate(180deg)";
    }

    static closed() {
      const arrow = document.getElementById(`${props.id}_selectArrow`);
      if (arrow) arrow.style.transform = "rotate(0deg)";
    }
  }

  function closeSelectIfClickOutside(e: MouseEvent) {
    const selectContainer = document.getElementById(props.containerId);
    if (!selectContainer?.contains(e.target as Node)) {
      setIsOpen(false);
      Arrow.closed();
    }
  }

  function getOptionByValue(value: typeof props.defaultValue) {
    if (value === undefined || value === null) return undefined;
    if (isReadonlyStringArray(value)) return undefined;

    const index = props.optionsValues.indexOf(String(value));
    if (index !== -1) {
      return props.options[index];
    }

    return undefined;
  }

  React.useEffect(() => {
    document.addEventListener("click", closeSelectIfClickOutside);
    return () =>
      document.removeEventListener("click", closeSelectIfClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="selectContainer" id={props.containerId}>
      <div
        className={`selectLabel ${props.className}`}
        id={props.id}
        onClick={() => {
          setIsOpen(!isOpen);
          if (isOpen) Arrow.closed();
          else Arrow.opened();
        }}
      >
        <span>{currentOption ? currentOption : props.label}</span>
        <div id={`${props.id}_selectArrow`} className="selectArrow">
          {props.iconArrow ? props.iconArrow : <></>}
        </div>
      </div>
      {isOpen && (
        <div
          className={`selectBox ${props.className} ${props.classNameBox}`}
          id={props.idBox}
        >
          {props.options.map((option, index) => (
            <span
              key={index}
              onClick={() => {
                setCurrentOption(props.options[index]);
                setIsOpen(false);
                if (props.selectValue)
                  props.selectValue(props.optionsValues[index]);
                Arrow.closed();
              }}
            >
              {option}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
